/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import Slider from 'react-rangeslider';
import 'react-rangeslider/lib/index.css';
import Hls from 'hls.js';
import { connect } from 'react-redux';
import { browser, getIp, os, SeoUrl } from '../utils';
import api from '../api';

const VolumeSlider = ({ changeVolume, changeMute }) => {
	const [value, setValue] = useState(100);
	const [volumeIcon, setVolumeIcon] = useState('volume-high-outline');
	const [isMute, setIsMute] = useState(false);

	const onChange = (value) => {
		setValue(value);
		changeVolume(value);

		if (value > 60) {
			setVolumeIcon('volume-high-outline');
		} else if (value <= 60 && value > 30) {
			setVolumeIcon('volume-medium-outline');
		} else if (value <= 30 && value > 0) {
			setVolumeIcon('volume-low-outline');
		} else {
			setVolumeIcon('volume-off-outline');
		}
	};

	const volumeMute = (mute) => {
		setIsMute(mute);
		changeMute(mute);
	};

	return (
		<>
			<button onClick={() => volumeMute(!isMute)}>
				<ion-icon name={isMute ? 'volume-mute' : volumeIcon}></ion-icon>
			</button>
			<Slider min={0} max={100} value={value} onChange={onChange} />
		</>
	);
};

const Favorite = ({ favorited, onClick }) => (
	<button className="favorite" onClick={() => onClick(!favorited)}>
		<div className={`toggle-liked${favorited ? ' active' : ''}`}>
			<div className="toggle-liked-sub">
				<ion-icon name={`heart${favorited ? '' : '-outline'}`}></ion-icon>
			</div>
		</div>
	</button>
);

const PlayerLive = ({ live, live_play, setPlayLive, settings, user, favoritePrograms, setFavoriteProgram }) => {
	const [isPlay, setIsPlay] = useState(false);
	const [isFavorite, setIsFavorite] = useState(true);
	const [volume, setVolume] = useState(0);
	const title = document.title;
	const playerRef = useRef();

	const play = async (status) => {
		setIsPlay(!status);
		setPlayLive(!status);
	};

	const changeVolume = (value) => {
		playerRef.current.volume = value / 100;
		setVolume(value);
	};

	const changeMuteStatus = (status) => {
		if (status) {
			playerRef.current.volume = 0;
		} else {
			playerRef.current.volume = volume / 100;
		}
	};

	const setFavorite = (status) => {
		setIsFavorite(status);

		if (Object.keys(live).length > 0 && Object.keys(user).length > 0) {
			setFavoriteProgram({ programs: live.programInfo.id, userId: user.id });
		}
	};

	useEffect(() => {
		const find = favoritePrograms && favoritePrograms.find((x) => x === live?.programInfo?.id);
		const status = typeof find === 'undefined' ? false : true;
		setIsFavorite(status);
	}, [favoritePrograms, live?.programInfo]);

	useEffect(() => {
		const run = async () => {
			setIsPlay(live_play);

			setTimeout(async () => {
				if (live_play) {
					playerRef.current.play();
					document.title = `► ${live?.programInfo?.name} yayında | ${title}`;

					if (Object.keys(live).length > 0 && Object.keys(user).length > 0) {
						const ip = await getIp();
						api.logs({
							userId: user.id,
							logType: 1,
							eventId: live.programInfo.id,
							ip,
							os: os(),
							bw: browser(),
						});
					}
				} else {
					playerRef?.current?.pause();
					if (live && Object.keys(live).length > 0 && live.programInfo.length > 0) {
						document.title = title.split(`► ${live.programInfo.name} yayında | `)[1];
					}
				}
			}, 300);

			// Adswizz dekorasyonu varsa bannerı başlat
			if (live_play && window.com_adswizz_synchro_decorateUrl) {
				const decorated = getDecoratedUrl();
				if (decorated) {
					fetchMetadata((parsedContext) => {
						triggerBannerAd(parsedContext);
					});
				}
			}
		};
		run();
	}, [live_play]);

	useEffect(() => {
		const finalUrl = getDecoratedUrl();
		//console.log('Decorated stream URL:', finalUrl);

		if (isPlay && playerRef.current) {
			if (Hls.isSupported()) {
				const hls = new Hls({
					xhrSetup: (xhr) => {
						xhr.withCredentials = true;
					},
				});
				hls.loadSource(finalUrl);
				hls.attachMedia(playerRef.current);
				hls.on(Hls.Events.MEDIA_ATTACHED, () => {
					playerRef.current.play().catch(console.error);
				});
			} else if (playerRef.current.canPlayType('application/vnd.apple.mpegurl')) {
				// Safari fallback
				playerRef.current.src = finalUrl;
				playerRef.current.addEventListener('loadedmetadata', () => {
					playerRef.current.play().catch(console.error);
				});
			}
		}
	}, [isPlay]);

	const getDecoratedUrl = () => {
		try {
			const decorated = window.com_adswizz_synchro_decorateUrl(settings.streamHLS);
			if (!decorated?.includes('.m3u8')) throw new Error('Invalid decorated url');
			return decorated;
		} catch (e) {
			//console.warn('Fallback to raw HLS URL due to decorate error:', e);
			return settings.streamHLS ?? '';
		}
	};

	const decoratedUrl = getDecoratedUrl();

	const fetchMetadata = (onContextParsed) => {
		const cacheBuster = Math.random() * 1e16;
		const url = `https://moondigitaledge2.radyotvonline.net:443/metadata?&cb=${cacheBuster}`;
		fetch(url, { credentials: 'include' })
			.then((res) => res.text())
			.then((text) => {
				const parsed = parseContextFromMetadata(text);
				if (parsed?.contextData && parsed?.milisec) onContextParsed(parsed);
			});
	};

	const parseContextFromMetadata = (data) => {
		const lines = data.split('\r\n');
		for (const line of lines) {
			if (line.startsWith('adswizzContext')) {
				const context = line.split(' ')[0].split('=')[1];
				const milisec = line.split(' ')[2].split('=')[1];
				return { contextData: context, milisec: parseInt(milisec) };
			}
		}
		return null;
	};

	const triggerBannerAd = ({ contextData, milisec }) => {
		const cacheBuster = Math.random() * 1e16;
		const adUrl = `https://moondigital.deliveryengine.adswizz.com/afr?zone_alias=DisplayZone&context=${contextData}&cb=${cacheBuster}`;

		setTimeout(() => {
			fetch(adUrl)
				.then((res) => res.text())
				.then((html) => {
					const bannerEl = document.getElementById('afrBanner');
					if (bannerEl) bannerEl.innerHTML = html;
				});

			// Otomatik kaldırmak istersen (opsiyonel)
			setTimeout(() => {
				const bannerEl = document.getElementById('afrBanner');
				if (bannerEl) bannerEl.innerHTML = '';
			}, milisec);
		}, 1000); // 1 sn sonra reklam başlasın
	};

	return (
		<div className="player">
			{isPlay && decoratedUrl && (
				<video
					ref={playerRef}
					id="audio"
					autoPlay
					muted={false}
					controls={false}
					style={{
						width: 0,
						height: 0,
						opacity: 0,
						position: 'absolute',
						pointerEvents: 'none',
					}}
				/>
			)}

			<button className="play" onClick={() => play(isPlay)}>
				{isPlay ? (
					<ion-icon name="pause" class="pause-icon"></ion-icon>
				) : (
					<>
						<ion-icon name="play" class="play-icon"></ion-icon>
						<ion-icon name="play" class="shadow-icon"></ion-icon>
					</>
				)}
			</button>

			{Object.keys(live).length > 0 && (
				<div className="program-info">
					<div className="program-image">
						<a href={`/program/${SeoUrl(live.programInfo.name)}-${live.programInfo.id}`}>
							<img src={live.programInfo.image} alt={live.programInfo.length > 0 ? live.programInfo[0].name : ''} />
						</a>
					</div>
					<div className="program-detail">
						<div className="program-name">
							<a href={`/program/${SeoUrl(live.programInfo.name)}-${live.programInfo.id}`}>{live.programInfo.name}</a>
						</div>
						<div className="program-broadcaster">
							{live.broadcasters.length > 0 &&
								live.broadcasters.map((broadcaster, i) => (
									<a key={i} href={`/programci/${SeoUrl(broadcaster.name)}-${broadcaster.id}`}>
										{broadcaster.name}
									</a>
								))}
						</div>
					</div>
				</div>
			)}

			<div className="volume">
				<VolumeSlider changeVolume={(val) => changeVolume(val)} changeMute={(status) => changeMuteStatus(status)} />
			</div>

			{user && Object.keys(user).length > 0 && <Favorite onClick={(status) => setFavorite(status)} favorited={isFavorite} />}

			<div id="afrBanner"></div>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		live: state.LiveStream.live,
		live_play: state.Play.live_play,
		settings: state.Settings.settings,
	};
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
	const { dispatch } = dispatchProps;
	const { actions: Play } = require('../redux/PlayRedux');

	return {
		...ownProps,
		...stateProps,
		setPlayLive: (status) => Play.setPlayLive(dispatch, status),
	};
};

export default connect(mapStateToProps, null, mergeProps)(PlayerLive);
